import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var LinkCss = i`
  :host {
    font-family: var(--isceco-font);
    display: inline-block;
  }
  
  a {
    text-decoration: none;
    cursor: pointer;
  }

  #link-element.container {
    color: var(--isceco-color-black-500);
  }

  #link-element.link {
    line-height: 1.5rem;
    font-weight: bold;
    color: var(--isceco-color-blue-500);
  }

  #link-element.link:hover {
    text-decoration: underline;
  }

  #link-element.link i.icon {
    margin-right: var(--isceco-space-100);
  }
`;
export { LinkCss as default };
